import { render, staticRenderFns } from "./InformationTwo.vue?vue&type=template&id=685ec5f2&"
import script from "./InformationTwo.vue?vue&type=script&lang=js&"
export * from "./InformationTwo.vue?vue&type=script&lang=js&"
import style0 from "../../../assets/css/dynamicInformation/Information.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports